import { createAction } from 'redux-starter-kit';
import { post, get } from '../../../../utility/via-fetch';
import { requestStart, requestSucceded, requestFailed } from '../../../domain/requests/RequestActions';
import { putUserGroup } from '../../../domain/company/companyActions';
import { addMessage } from '../../application/messageUiActions';
import { putAppConfig } from '../../../domain/appConfig/appConfigActions';
import routeLocations from '../../../../utility/route-locations';
import { selectCurrencies } from '../../../domain/appConfig/appConfigReducer';

export const fetchCompanyPageData = createAction('FETCH_COMPANY_PAGE_DATA');

export function requestPageData() {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchCompanyPageData.toString()));
    dispatch(fetchCompanyPageData(requestId));

    try {
      const [userGroup, languages, countries, currencies] = await Promise.all([
        get('/api/user-groups/my-group'),
        get('/api/application-configurations/languages'),
        get('/api/application-configurations/countries'),
        get('/api/application-configurations/currencies'),
      ]);

      // Update the state with our new data
      dispatch(putUserGroup(userGroup));
      dispatch(putAppConfig({ applicationConfigCode: 'countries', countries }));
      dispatch(putAppConfig({ applicationConfigCode: 'currencies', currencies }));
      dispatch(putAppConfig({ applicationConfigCode: 'languages', languages })); // Update the domain state with our newly loaded user.

      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error)); // We failed.
    }
  };
}

/*
 * An action that signifies a request to load user group data
 */
export const fetchUserGroup = createAction('FETCH_GROUP');

/*
 * A action that send and password reset request token to the server to check prove the users email is verified and to give them a new password.
 */
export function requestUserGroupDetails() {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchUserGroup.toString()));
    dispatch(fetchUserGroup(requestId));
    try {
      const userGroup = await get('/api/user-groups/my-group', undefined, {});
      // sign them in.
      dispatch(putUserGroup(userGroup));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error)); // We failed.
    }
  };
}

/*
 * An action that signifies a request to update user group data
 */
export const updateUserGroupRequest = createAction('UPDATE_GROUP');


export function updateUserGroup(userGroup, history, wizard, wizardNext) {
  return async (dispatch, getState) => {
    const requestId = dispatch(requestStart(updateUserGroupRequest.toString()));
    dispatch(updateUserGroupRequest(requestId));
    try {
      await post('/api/user-groups/my-group', { wizard: wizard }, userGroup);

      dispatch(putUserGroup({
        ...userGroup,
        currency: selectCurrencies(getState()).find(e => e.currencyCode === userGroup.currencyCode),
      }));

      // Next wizard or go back to the read only screen
      if (wizard) {
        wizardNext(false);
      } else history.push(routeLocations.configure_contact_details); // Kick them back to the read only screen

      dispatch(addMessage('success', 'itemUpdated', { item: userGroup.description }));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

/*
 * An action that signifies a request to get the list of java countries (in the users language)
 * I put this in company as I'm not sure whether to do this in the users loanguage or the companies language.
 */
export const fetchCountries = createAction('GET_COUNTRIES');

export function requestCountryList() {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(updateUserGroupRequest.toString()));
    dispatch(updateUserGroupRequest(requestId));
    try {
      const countries = await get('/api/application-configurations/countries', undefined, {});
      // Save it locally
      dispatch(putAppConfig({ applicationConfigCode: 'countries', countries }));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error)); // We failed.
    }
  };
}
